// Client-side id for a not-yet-persisted draft row. Prefers crypto.randomUUID;
// falls back to a timestamp+random token for environments without it (e.g. older
// jsdom in tests). Server rows keep their own UUID once created.
export const newRowId = (): string =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `row-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
